import { get } from 'lodash';
import * as uuid from 'uuid';

import { LD_TARGET_ID_LOCAL_STORAGE_KEY } from '@funnels/constants';

import cookieStorageUtil from './cookieStorage';
import { datadogUtil } from './datadogRum';

// Disable browser's scroll history.
if (get(window, 'history.scrollRestoration')) {
  window.history.scrollRestoration = 'manual';
}

datadogUtil.init();

// Set a new user experience id if needed
if (!cookieStorageUtil.get(LD_TARGET_ID_LOCAL_STORAGE_KEY)) {
  cookieStorageUtil.set(LD_TARGET_ID_LOCAL_STORAGE_KEY, uuid.v4());
}
